import { Action, Reducer } from "redux";
import {
	ParameterByTypeScreenState,
	ParameterByTypeScreenTypes,
	ParameterByTypeScreenActionTypes,
} from "./parameterByTypeScreenTypes";
import {
	INITIAL_REDUCER_DATA,
	haskeyReducer,
	updateGetIsolated,
	updateSaveIsolated,
} from "@/main/services/reducerUtils";

export const INITIAL_STATE: ParameterByTypeScreenState = {
	parameterByTypeScreen: {
		data: INITIAL_REDUCER_DATA,
	},
	isolated: {},
};

const parameterByTypeScreenReducer: Reducer<ParameterByTypeScreenState> = (
	state: ParameterByTypeScreenState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as ParameterByTypeScreenActionTypes;
	switch (actionTypes.type) {
		case ParameterByTypeScreenTypes.GET_PARAMETER_BY_TYPE: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) return updateGetIsolated(state, actionTypes);

			return {
				...state,
				parameterByTypeScreen: {
					...state.parameterByTypeScreen,
					isLoading: true,
				},
			};
		}
		case ParameterByTypeScreenTypes.SAVE_PARAMETER_BY_TYPE: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

			return {
				...state,
				parameterByTypeScreen: {
					...state.parameterByTypeScreen,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case ParameterByTypeScreenTypes.RESET_REDUCER_PARAMETER_BY_TYPE:
			return {
				...state,
				parameterByTypeScreen: INITIAL_STATE.parameterByTypeScreen,
			};
		default:
			return state;
	}
};

export default parameterByTypeScreenReducer;
